import * as React from 'react'
import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/swiper.scss'
import { HourRankItem, RankItem } from '@pubts/fetch'
import { None, WebAnchorItem, WithPage } from '@huyafed/comp'
const { useEffect } = React;
interface Props {
  data1: HourRankItem[];
  data: RankItem[];
  iHour: number;
}
const Hour: React.FC<Props> = props => {

  useEffect(() => {
    if (props.data1.length === 0) return;
    let swipers: any = null;
    // tslint:disable-next-line: no-unused-expression
    swipers = new Swiper('.swiper-container', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      initialSlide: props.data1.length - 1,
      slidesPerView: 3,
      observer: true,
    })
    return () => {
      console.log('卸载了')
      swipers = null;
    }
  }, [props.data1])
  return (
    <div className='web-hour'>
      <div className='web-hour-top'>
        <div className="swiper-button-prev"></div>
        <div className="swiper-container">
          {
            props.data1.length !== 0 ?
              <div className="swiper-wrapper">
                {
                  props.data1.map((item: HourRankItem) => (
                    <div key={Math.random()} className='swiper-slide'>
                      <div className='avatar'>
                        <img
                          title={item.tItem.sNickName}
                          src={item.tItem.sLogoUrl}
                          onError={(event: any): void => {
                            event.target.onerror = null;
                            event.target.src = 'https://diy-assets.msstatic.com/Activity-Public-Image/default-1.png';
                          }}
                          onClick={(): void => {
                            window.open('https://m.huya.com/' + item.tItem.tJump.iRoomId, '_blank');
                          }}
                        />
                        <div className='label'>{item.iHour}时冠军</div>
                      </div>
                      <p
                        className='name'
                        onClick={(): void => {
                          window.open('https://m.huya.com/' + item.tItem.tJump.iRoomId, '_blank');
                        }}
                      >{item.tItem.sNickName}</p>
                    </div>
                  ))
                }
              </div>
              :
              <None text='暂无小时冠军数据' />
          }
        </div>
        <div className="swiper-button-next"></div>
      </div>
      <div className='web-hour-bottom'>
        <div className='hourDesc'>
          <i />
          {props.iHour}时小时榜
        </div>
        <ul
          style={{
            width: '450px',
            display: 'flex',
            color: '#519ff7',
            fontSize: '14px',
            justifyContent: 'space-between',
            margin: '10px 0px 10px 0px',
          }}
        >
          <li>排名</li>
          <li>主播昵称</li>
          <li>小时车技</li>
        </ul>
        <ul className='web-hour-list'>
          {
            props.data.length === 0 ?
              <None text={'暂无飙车总榜数据'} />
              :
              props.data.map((item: any) => {
                return (
                  <WebAnchorItem
                    key={item.tJump.lPid}
                    width={450}
                    isLarge={false}
                    color={'white'}
                    borderColor={'#53abfd'}
                    canJump={true}
                    msg={{...item, tJump: {...item.tJump, bIsLive: item.tJump.iIsLive}}}
                  />
                )
              })
          }
        </ul>
        {props.children}
      </div>
    </div>
  )
}
export default WithPage(Hour);